var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4118 20.7034V16.7906H23.4313C24.2588 16.7906 24.9573 16.5133 25.5267 15.9664L25.6634 15.8278C26.7035 14.6955 26.6352 12.9316 25.5267 11.8841C24.9725 11.3295 24.2133 11.0291 23.4313 11.0445H20.1895V20.7034H21.4118ZM21.4119 15.6043V12.2306H23.4621C23.9025 12.2306 24.3202 12.4001 24.6315 12.7082C25.2921 13.3552 25.3073 14.4335 24.6695 15.1036C24.3581 15.4349 23.9177 15.6197 23.4621 15.6043H21.4119ZM31.3648 14.6107C30.841 14.1254 30.1273 13.879 29.2239 13.879C28.0623 13.879 27.1892 14.3103 26.6122 15.1653L27.6902 15.8508C28.085 15.2654 28.6241 14.9727 29.3074 14.9727C29.7401 14.9727 30.1577 15.1345 30.4841 15.4272C30.803 15.7045 30.9852 16.105 30.9852 16.5286V16.8136C30.5145 16.5517 29.9223 16.4131 29.1935 16.4131C28.3432 16.4131 27.6599 16.6134 27.1512 17.0216C26.6425 17.4298 26.3844 17.969 26.3844 18.6545C26.3692 19.2784 26.6349 19.8715 27.1057 20.272C27.584 20.7034 28.1913 20.919 28.905 20.919C29.7477 20.919 30.4158 20.5416 30.9245 19.7868H30.9776V20.7034H32.1468V16.6288C32.1468 15.7738 31.8887 15.096 31.3648 14.6107ZM28.047 19.4864C27.7964 19.3016 27.6445 19.0012 27.6445 18.6777C27.6445 18.3157 27.8116 18.0153 28.1381 17.7765C28.4722 17.5377 28.8898 17.4145 29.3834 17.4145C30.0668 17.4068 30.5983 17.5608 30.978 17.8689C30.978 18.3927 30.773 18.8471 30.3705 19.2322C30.0061 19.602 29.5125 19.8099 28.9961 19.8099C28.6544 19.8176 28.3203 19.7021 28.047 19.4864ZM34.7744 23.6072L38.859 14.0947H37.5304L35.6399 18.8394H35.6171L33.6812 14.0947H32.3525L35.0326 20.2798L33.5141 23.6072H34.7744Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1915 15.9439C17.1915 15.5665 17.1611 15.1891 17.1004 14.8193H11.9453V16.9529H14.8986C14.7772 17.6384 14.3824 18.2546 13.8054 18.6398V20.0262H15.5668C16.5993 19.0634 17.1915 17.6385 17.1915 15.9439Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9442 21.3666C13.4171 21.3666 14.6622 20.8737 15.5657 20.0264L13.8043 18.64C13.3108 18.9789 12.6807 19.1714 11.9442 19.1714C10.5169 19.1714 9.30977 18.1932 8.87702 16.8838H7.0625V18.3165C7.98874 20.1882 9.87917 21.3666 11.9442 21.3666Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87795 16.8839C8.65015 16.1983 8.65015 15.4512 8.87795 14.758V13.333H7.06315C6.28103 14.8966 6.28103 16.7452 7.06315 18.3088L8.87795 16.8839Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9442 12.47C12.7262 12.4546 13.4778 12.755 14.0397 13.3018L15.6036 11.7151C14.6091 10.7754 13.3032 10.2593 11.9442 10.2747C9.87917 10.2747 7.98874 11.4609 7.0625 13.3326L8.87702 14.7653C9.30977 13.4482 10.5169 12.47 11.9442 12.47Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google_pay.faf946c50e4cb3a138f954766c49bc0c.svg";
export { ForwardRef as ReactComponent };